export const classes = {
  icon: 'size-5',
};
